const I = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NTAgMzAwIj4KPHJlY3Qgd2lkdGg9IjQ1MCIgaGVpZ2h0PSIzMDAiIGZpbGw9IiNGRkZGRkYiLz4KPHJlY3Qgd2lkdGg9IjQ1MCIgaGVpZ2h0PSIyMDAiIHk9IjEwMCIgZmlsbD0iI0ZGMDAwMCIvPgo8cmVjdCB3aWR0aD0iNDUwIiBoZWlnaHQ9IjEwMCIgeT0iMjAwIiBmaWxsPSIjRkZERjAwIi8+Cjwvc3ZnPg==";
export {
  I as default
};
//# sourceMappingURL=GE-OS-01822a9e.mjs.map
